export default __webpack_public_path__ + "images/models/b8ae11812870c29ca9d73977fe5f6a06.glb";